<app-social-insights *ngIf="selectedInsightsCampaignType === 'social'"></app-social-insights>
<app-location-insights *ngIf="selectedInsightsCampaignType === 'location'"></app-location-insights>
<app-poster-insights *ngIf="selectedInsightsCampaignType === 'poster'"></app-poster-insights>